export default __webpack_public_path__ + "static/media/island_5.bf454560.png";